<!-- h5/视频 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<div class="search-bar">
					<img src="../assets/search-icon.png" class="search-icon">
					<input placeholder="请输入关键字进行搜索" class="search-input" @click="$router.push('/search')" />
				</div>
			</div>
			<ul class="tab-list">
         <li :class="{ active: params.is_tj === 1 }" @click="checkTab(0, 1)">推荐</li>
<!--        <li :class="{ active: params.type === 2 }" @click="checkTab(2, 0)">系列</li>-->
<!--        <li :class="{ active: params.type === 1 }" @click="checkTab(1, 0)">单个</li>-->
        <li :class="{ active: params.type === 2 }" @click="$router.push('/video-classification?type=2')">系列</li>
        <li :class="{ active: params.type === 1 }" @click="$router.push('/video-classification?type=1')">单个</li>
			</ul>
		</div>
    <!--  视频列表  -->
    <video-recommend v-if="params.is_tj === 1" style="padding: 12px 15px;"></video-recommend>
    <!--  分类列表  -->
<!--    <video-classification v-else :type="params.type"></video-classification>-->

		<div class="float-box" @click="show = true">
			<img src="../assets/icon-9.png">
			发布视频
		</div>

		<!-- 发布弹窗 -->
    <van-overlay :show="show" z-index="99999">
      <div class="window">
        <div class="window-top">
          <button type="button" class="window-btn" @click.stop="show = false; $router.push('/paid-contribution-video?type=1')">
            <img src="../assets/camera-2.png">发布有偿视频
          </button>
          <button type="button" class="window-btn del" @click.stop="show = false; $router.push('/free-information')">
            <img src="../assets/camera-1.png">发布无偿视频
          </button>
        </div>
        <div class="window-btn-box">
          <button type="button" @click="show = false">
            <img src="../assets/close-icon3.png">
          </button>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
	import {VideoService} from "@/common/service";
  import VideoRecommend from "@/components/video-recommend";
  import VideoClassification from "@/components/video-classification";

  export default {
		components: {VideoClassification, VideoRecommend},
		data() {
			return {
        show: false,
        params: {
          type: 0,  // 类型1单个2系列
          is_tj: 1,  // 是否推荐0否1是
          page: 1,  // 页数
          page_num: 20,  // 每页数
        },
        list: [],
        loading: false,
        finished: false,
			};
		},
    mounted() {
    },
    methods: {
      getList() {
        this.loading = true;
        VideoService.getVideoList(this.params).then(({ data }) => {
          const list = data.list;
          this.list = this.params.page === 1 ? list : [...this.list, ...list];
          if (list.length < this.params.page_num) {
            this.finished = true;
          } else {
            this.params.page++;
          }

        }).finally(() => {
          this.loading = false;
        });
      },
      checkTab(type, is_tj) {
        this.params.type = type;
        this.params.is_tj = is_tj;
        // this.finished = false;
        // this.params.page = 1;
        // this.getList();
      },
    },
    // 清除页面缓存
    beforeRouteLeave(to, from, next) {
      // return next();
      // if (to.path === "/video-details") {
      if (from.meta.toPagesKeep.includes(to.path)) {
        from.meta.keepAlive = true;
      } else {
        let vnode = this.$vnode;
        let parentVnode = vnode && vnode.parent;
        if (parentVnode && parentVnode.componentInstance && parentVnode.componentInstance.cache) {
          var key = vnode.key == null
              ? node.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
              : vnode.key;
          var cache = parentVnode.componentInstance.cache;
          var keys = parentVnode.componentInstance.keys;
          if (cache[key]) {
            this.$destroy();
            // remove key
            if (keys.length) {
              var index = keys.indexOf(key);
              if (index > -1) {
                keys.splice(index, 1)
              }
            }
            cache[key] = null;
          }
        }
      }
      next();
    },
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 84px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99999999;
		background-color: #FFFFFF;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		z-index: 99999998;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.return-img {
		width: 20px;
		margin-right: 10px;
	}

	.search-bar {
		width: calc(100% - 65px);
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 16px;
		margin-right: 10px;
	}

	.search-input {
		flex: 1;
		font-size: 15px;
	}

	.search-input::placeholder {
		color: #B6B6B6;
	}

	.tab-list {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		color: #888888;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}

	.wrap {
		width: 100%;
		height: calc(var(--vh) * 100 - 84px);
		display: flex;
		flex-direction: column;
		margin: 84px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow: auto;
	}

	.video-list>li {
		width: calc(50% - 7.5px);
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		margin-bottom: 12px;
		border-radius: 10px;
		box-shadow: 0 1px 16px rgba(0, 0, 0, 0.12);
		overflow: hidden;
	}
  .video-list>li:nth-child(7n + 1) {
    width: 100%;
  }

	.float-box {
		width: 46px;
		height: 46px;
		border-radius: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #FFFFFF;
		font-size: 10px;
		font-weight: 500;
		box-shadow: 0 1px 8px rgba(42, 99, 243, 0.6);
		position: fixed;
		right: 15px;
		bottom: 80px;
		background-color: #2A63F3;
	}

	.float-box>img {
		width: 16px;
	}

	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 99999999;
	}

	.window-top {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.window-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-weight: 500;
		font-size: 16px;
		margin-bottom: 40px;
	}

	.window-btn>img {
		width: 60px;
		margin-right: 10px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 40px 0;
		box-sizing: border-box;
	}

	.window-btn-box>button {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.window-btn-box>button>img {
		width: 40px;
	}
	
	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 100px 0;
	}
	
	.normal-box>img {
		width: 150px;
		margin-bottom: 9px;
	}


</style>
